import { RouterProvider } from 'react-router';
import ErrorBoundary from '@/components/ErrorBoundary';
import QueryProvider from '@/providers/QueryProvider';
import { router } from '@/router';

export default function App() {
  return (
    <ErrorBoundary>
      <QueryProvider>
        <RouterProvider router={router} />
      </QueryProvider>
    </ErrorBoundary>
  );
}
